module.exports = __webpack_public_path__ + "img/topup_header_d_no_diamond.c81b8d9b.png";